import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { BenefitsSection } from './components/BenefitsSection';
import { IncludesSection } from './components/IncludesSection';
import { ResultsSection } from './components/ResultsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="min-h-screen bg-artisanal-cream font-sans text-artisanal-brown selection:bg-artisanal-terracotta selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <BenefitsSection data-id="element-3" />
      <IncludesSection data-id="element-4" />
      <ResultsSection data-id="element-5" />
      <ForWhoSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <OfferSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <FooterSection data-id="element-10" />
    </div>;
}